import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/menu";

export const getAllMenu = () => axios.get(API_PATH + "/all");
export const searchByPage = (obj) =>
  axios.post(API_PATH + "/search-by-page", obj);

export const getMenuById = (id) => axios.get(API_PATH + "/get-by-id/" + id);

export const saveOrUpdateMenu = (obj) =>
  axios.post(API_PATH + "/save-or-update", obj);

export const deleteMenu = (id) => axios.delete(API_PATH + "/delete/" + id);
